export default __webpack_public_path__ + "static/media/info.2b20f7c7.svg";